import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({ paidAt: Yup.date().required() });
